import React from "react";
import styled from "styled-components";
import { Icon } from "../../components/icons";
import { useFetchable } from "../../store/common/fetchable";
import { isFetchableSuccess } from "../../store/common/fetchable/helpers";
import { Users } from "../../store/users/reducer";
import { colours } from "../../styles/colours";

const MedalIcon = styled(Icon).attrs({ type: "medal", colour1: colours.gold })`
  margin-left: 0.5em;
`;

export const BelieverBadge: React.FunctionComponent<{}> = () => {
  const currentUser = useFetchable(Users.current);

  return isFetchableSuccess(currentUser) && currentUser.data.believer ? (
    <MedalIcon />
  ) : null;
};
